// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1S9rY","unreadBadge":"styles_unreadBadge__3B0b7","modalContent":"styles_modalContent__2OBBL","modal":"styles_modal__3WkJ3"};